export enum TesterStatusInCycle {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  AwaitingReview = 'awaitingReview',
  Finished = 'finished',
}
